import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';

@Component({
	selector: 'NgxPageSize',
	//inputs: ['placeholder', 'compid', 'complist', 'searchKey'],
	templateUrl: './ngxPageSize.component.html'
})
export class NgxPageSize {
	@Input() limit : string;
	@Output() changePageSize = new EventEmitter();

	pageLimitOptions = [10, 15, 25, 50, 75, 100];
	constructor(){

	}

	ngOnInit(){

	}

	onChangePageSize(){
		this.changePageSize.emit(this.limit);
	}
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/shared/ngxGrid/ngxPageSize.component.ts